var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3a3c43",
    fillRule: "evenodd",
    d: "M4.726 4.125a6.438 6.438 0 0 1 3.052-1.176V1.455h-.722a.725.725 0 0 1-.723-.728c0-.401.324-.727.723-.727h2.888c.4 0 .723.326.723.727a.725.725 0 0 1-.723.728h-.722v1.494a6.434 6.434 0 0 1 2.88 1.057l.878-.884a.719.719 0 0 1 1.022 0 .73.73 0 0 1 0 1.029l-.79.795A6.547 6.547 0 0 1 15 9.455C15 13.07 12.09 16 8.5 16S2 13.07 2 9.455c0-1.674.624-3.2 1.65-4.358l-.94-.946a.73.73 0 0 1 0-1.029.719.719 0 0 1 1.02 0l.996 1.003zM8.5 14.545c2.792 0 5.056-2.279 5.056-5.09 0-2.812-2.264-5.091-5.056-5.091-2.792 0-5.056 2.279-5.056 5.09 0 2.812 2.264 5.091 5.056 5.091zm.53-4.597a.719.719 0 0 1-1.02.04.73.73 0 0 1-.04-1.027l2.004-2.182a.719.719 0 0 1 1.02-.04.73.73 0 0 1 .04 1.028L9.03 9.948z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.c96e335e01ec1d9087cc2b8ac25b1cba.svg";
export { ForwardRef as ReactComponent };